"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackUserFeedbackActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const feedbackQuestions_1 = __importDefault(require("../../common/feedbackQuestions"));
const snowplowConfig_1 = require("../../common/snowplowConfig");
const trackUserFeedbackActivity = (action) => {
    (0, snowplowConfig_1.trackSnowplowEvent)(snowplowConfig_1.SnowplowEventSchema.ActionSchema, { action });
};
exports.trackUserFeedbackActivity = trackUserFeedbackActivity;
const trackFeedbackAnswer = (question, answer) => {
    (0, snowplowConfig_1.trackSnowplowEvent)(snowplowConfig_1.SnowplowEventSchema.QuestionSchema, {
        question,
        answer,
    });
};
function withSnowplowTracking(Component) {
    return function WithSnowplowTracking({ logQuestionAnswered, onDismiss, ...rest }) {
        const [isQuestionnaireComplete, setIsQuestionnaireComplete] = (0, react_1.useState)(false);
        const onAnswerSubmit = (question, answer, questionIndex) => {
            // Check if this is the answer to the final question
            setIsQuestionnaireComplete(questionIndex === feedbackQuestions_1.default.length - 1);
            logQuestionAnswered(questionIndex);
            trackFeedbackAnswer(question, answer);
        };
        const onClose = () => {
            (0, exports.trackUserFeedbackActivity)(isQuestionnaireComplete
                ? snowplowConfig_1.SnowplowAction.SurveyCompleted
                : snowplowConfig_1.SnowplowAction.SurveyDismissed);
            onDismiss?.(isQuestionnaireComplete);
        };
        const onSurveyClick = () => {
            (0, exports.trackUserFeedbackActivity)(snowplowConfig_1.SnowplowAction.ExternalSurveyClick);
            onDismiss?.(isQuestionnaireComplete);
        };
        const onGiveFeedbackClick = () => {
            (0, exports.trackUserFeedbackActivity)(snowplowConfig_1.SnowplowAction.GiveFeedbackClick);
        };
        return ((0, jsx_runtime_1.jsx)(Component, { isQuestionnaireComplete: isQuestionnaireComplete, onAnswerSubmit: onAnswerSubmit, onClose: onClose, onGiveFeedbackClick: onGiveFeedbackClick, onSurveyClick: onSurveyClick, ...rest }));
    };
}
exports.default = withSnowplowTracking;
//# sourceMappingURL=index.js.map